module.exports = __webpack_public_path__ + "img/by.54f7e3da.svg";